import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
  (response) => {
    const version = localStorage.getItem('version');
    const listVersion = version?.length > 7 ? JSON?.parse(version) : version
    const versionOrders = version?.length > 7 ? listVersion?.orders_version : version
    const versionValidate = versionOrders > 4 ? JSON?.parse(versionOrders)?.length : JSON?.parse(version)?.length

    const currentVersion = response.headers?.version;
    const objectVersions = {
      catalog_version: listVersion?.catalog_version,
      auth_version: listVersion?.auth_version,
      orders_version: response.headers?.version,
      manufactures_version: listVersion?.manufactures_version,
      providers_version: listVersion?.providers_version,
      restaurants_version: listVersion?.restaurants_version,
      cache_version: listVersion?.cache_version,
    }

    if (!versionOrders || versionOrders !== currentVersion) {
      localStorage.setItem('version', JSON.stringify(objectVersions));
    }

    if (
      versionValidate &&
      versionOrders !== currentVersion &&
      versionOrders !== null &&
      versionOrders !== 'undefined' &&
      currentVersion !== undefined
    ) {
      location.reload(true);
    }

    return response;
  },
  (error) => Promise.reject(error)
);

export default instance;
